/**
 * PATH: packages/ui/src/kanban/components/cardAllocateHotkey.ts
 * FILE_ID: UI-KANBAN-CARD-ALLOCATE-HOTKEY-001
 * PURPOSE: Ask one card to open its Allocate picker from the board A key.
 * ROLE IN ARCHITECTURE: Tiny bridge so the key handler does not own card state.
 * MAIN EXPORTS: requestCardAllocate, takePendingAllocate
 * NON-RESPONSIBILITIES: Does not place the card or render the picker.
 * NOTES FOR FUTURE AI: The pending set covers the frame before the rail mounts.
 */

const pending = new Set<string>()

export function requestCardAllocate(cardId: string): void {
  pending.add(cardId)
  window.dispatchEvent(new CustomEvent('kanban:open-card-allocate', {
    detail: { cardId },
  }))
}

export function takePendingAllocate(cardId: string): boolean {
  return pending.delete(cardId)
}
